<template>
  <section class="support-log">
    <div class="title-container">
      <h2>Log</h2>
    </div>
    <div class="log-container">
      <div
        v-for="(item, index) in logsData"
        :key="index"
        class="log-box">
        <div class="left">
          <span
            v-if="item.type==201"
            class="icon-box call-icon">
            <font-awesome-icon icon="pen" />
          </span>
          <span
            v-else-if="item.type==300"
            class="icon-box ticket-icon">
            <font-awesome-icon icon="plus" />
          </span>
          <span
            v-else-if="item.type==301"
            class="icon-box call-icon">
            <font-awesome-icon icon="money-bill-alt" />
          </span>
          <span
            v-else-if="item.type==401"
            class="icon-box call-icon">
            <font-awesome-icon icon="handshake" />
          </span>
          <span
            v-else-if="item.type==501"
            class="icon-box call-icon">
            <font-awesome-icon icon="heart-crack" />
          </span>
          <span
            v-else
            class="icon-box sms-icon">
            <font-awesome-icon icon="comment" />
          </span>
        </div>
        <div class="right">
          <div
            class="info-container white"
          >
            <div class="flex-sb">
              <span class="title">{{ item.title }}</span>
              <span class="time">{{ item.created_at }}</span>
            </div>
            <div class="info">
              <span>
                {{ item.sender_type===1 ? 'CS': item.sender_type == 3? item.agent : 'Customer' }}
                <span>{{ item.agent }}</span>
              </span>
            </div>
            <div
              v-if="item.message!=='null'&&item.message!=='undefined'"
              class="message-content">
              <span>{{item.message}} </span>
            </div>

          </div>
        </div>
      </div>
      <div
        v-if="logsData.length < 1"
        class="tips" >
        <span>No Data</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'detailLog',
  props:{
    logsData:{
      type:Array,
      default:()=>([])
    }
  },
  data(){
    return{
    }
  }
}
</script>

<style lang="scss" scoped>
  .support-log {
    .svg-inline--fa {
      color: white;
      font-size: 24px;
    }
    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tips {
      padding-top: 50px;
      font-size: 14px;
      text-align: center;
    }
    .log-container {
      margin-top: 12px;
      .log-box {
        display: flex;
        margin-bottom: 15px;
        &:last-child {
          .left::after {
            width: 0;
          }
        }
        .left {
          position: relative;
          &::after {
            position: absolute;
            z-index: 1;
            content: "";
            width: 5px;
            background: #dddfe7;
            top: 50px;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
          }
          span {
            z-index: 2;
            display: block;
            width: 50px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 100%;
          }
           .icon-box {
             display: flex;
             align-items: center;
             justify-content: center;
           }
          .sms-icon {
            background: #68c23a;
          }
          .edit-icon {
            background: #e6a23d;
          }
          .remark-icon {
            background: #409eff;
          }
          .call-icon {
            background: #68c23a;
          }
          .ticket-icon {
            background: #91939a;
          }
        }
        .right {
          flex: 1;
          position: relative;
          margin-left: 15px;
          .info-container {
            padding: 10px 15px 0 15px;
            border: 1px solid #c5e7b1;
            border-radius: 4px;
            background-color: #f0faeb;
            &.white {
              border: 1px solid #DDDFE7;
              background-color: white;
            }
            .message-content {
              border-top: 1px solid #DDDFE7;
            }
          }
          .info-file {
            margin-top: 10px;
          }
          .info {
            padding-bottom: 5px;
            & > span {
              display: block;
              padding-bottom: 5px;
              font-size: 14px;
              font-weight: 500;
              color: #91939a;
              span {
                display: inline-block;
                padding-left: 5px;
                font-weight: 400;
              }
            }
          }
          .file-container {
            margin-top: 10px;
          }
          .file-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            padding: 0 15px;
            height: 65px;
            border: 1px solid #dddfe7;
            border-radius: 4px;
            background: #fcfcfc;
            &:last-child {
              margin-bottom: 5px;
            }
            .file-info {
              color: #616266;
              font-size: 16px;
            }
          }
          .blue {
            color: #1989fa;
          }
          .title {
            font-weight: bold;
            font-size: 16px;
          }
          .message-content {
            margin: 0 -15px;
            padding: 5px 15px;
            border-top: 1px solid #c5e7b1;
            white-space: pre-wrap;
            word-break: break-word;
          }
          .time {
            display: block;
            padding-left: 10px;
            // position: absolute;
            // top: 15px;
            // right: 15px;
            color: #91939a;
            font-size: 14px;
            font-weight: 500;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
